/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { configure, pagination } from 'instantsearch.js/es/widgets';
import { connectMenu } from 'instantsearch.js/es/connectors';
import customHitsPost from './widgets/hits-post';
import customHitsRecipe from './widgets/hits-recipe';
import contentSelect from '../dial/select-content';
import animations from '../animations';
import slider from '../slider';
import quiz from '../quiz';
import timer from '../timer';
import collapsable from '../collapsable';
import { handleResponse } from '../../utils';

const searchPostResults = document.querySelector('.js-occasion-search-post-results');

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    return {
        ...algoliaClient,
    };
};

const updateContent = (occasion) => {
    // get page title
    const title = document.querySelector('.js-occasion-title');

    // get recipe link
    const recipesLink = document.querySelector('.js-occasion-recipe-link');

    if (occasion === 'all') {
        title.innerHTML = title.dataset.allContent;
        document.querySelector('.js-occasion-recipe-title').textContent = 'Recipes';
        document.querySelector('.js-occasion-post-title').textContent = 'Articles';
        recipesLink.textContent = 'See all recipes';
        recipesLink.setAttribute('href', `${SWDLocalise.homeUrl}/recipes/`);
        document.querySelector('.js-occasion-components').innerHTML = '';

        // trigger scroll animations
        window.dispatchEvent(new CustomEvent('resize'));
        return;
    }

    const formattedOccasion = occasion.split('-').join(' ');
    title.innerHTML = `<h1>${formattedOccasion}</h1>`;
    document.querySelector('.js-occasion-recipe-title').textContent = `${formattedOccasion} Recipes`;
    document.querySelector('.js-occasion-post-title').textContent = `${formattedOccasion} Articles`;
    recipesLink.textContent = `${formattedOccasion} recipes`;
    recipesLink.setAttribute('href', `${SWDLocalise.homeUrl}/recipes/?occasion=${occasion}`);

    // get page components
    const container = document.querySelector('.js-occasion-components');
    container.innerHTML = '<div class="o-mb60 u-center"><svg class="c-icon c-loader-icon"><use xlink:href="#icon-loader"></use></svg></div>';

    const data = new FormData();
    data.append('action', 'swd_get_page_components');
    data.append('nonce', container.dataset.nonce);
    data.append('category', occasion);
    data.append('tax', 'occasion');

    fetch(SWDLocalise.ajaxUrl, {
        method: 'POST',
        cache: 'no-cache',
        body: data,
    })
        .then(handleResponse)
        .then((response) => {
            if (response.success) {
                container.innerHTML = response.data.components;
                animations();
                slider();
                quiz();
                timer();
                collapsable();
            }
        })
        .catch((error) => {
            console.error(error); // eslint-disable-line no-console
        });

    // trigger scroll animations
    window.dispatchEvent(new CustomEvent('resize'));
};

const getPosts = (searchClient) => {
    const indexName = `${SWDLocalise.algoliaIndex}post`;

    let firstRender = false;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const urlParts = location.href.match(/^(.*?)\/occasions/);
                    const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

                    const occasionPath = routeState.occasion
                        ? `${routeState.occasion}/`
                        : '';

                    const queryParameters = {};

                    // page
                    if (routeState.batch !== 1) {
                        queryParameters.batch = routeState.batch;
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${baseUrl}occasions/${occasionPath}${queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const pathnameMatches = location.pathname.match(/occasions\/(.*?)\/?$/);
                    const occasion = ((pathnameMatches && pathnameMatches[1]) || '');
                    const {
                        batch,
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    return {
                        batch,
                        occasion,
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_spb_post || {};
                    return {
                        batch: indexUiState.page,
                        occasion: indexUiState.menu && indexUiState.menu['taxonomies.occasion'],
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_spb_post: {
                            page: routeState.batch,
                            menu: {
                                'taxonomies.occasion': routeState.occasion,
                            },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            const page = helper.getPage() || 0;

            helper
                .toggleFacetRefinement('visibility', 'visible')
                .setPage(page);

            if (!firstRender) {
                if (searchPostResults
                    && searchPostResults.dataset.selected !== undefined
                    && searchPostResults.dataset.selected !== 'all') {
                    helper
                        .clearRefinements('taxonomies.occasion')
                        .toggleFacetRefinement('taxonomies.occasion', searchPostResults.dataset.selected);
                }
                firstRender = true;
            }

            helper.search();
        },
    });

    const virtualMenuOccasion = connectMenu(() => null);
    const virtualMenuVisibility = connectMenu(() => null);

    search.addWidgets([
        configure({
            hitsPerPage: 4,
            hierarchicalFacets: [{
                name: 'occasions',
                attributes: ['taxonomies.occasion.lvl0'],
            }],
        }),

        virtualMenuOccasion({
            attribute: 'taxonomies.occasion',
        }),

        virtualMenuVisibility({
            attribute: 'visibility',
        }),

        customHitsPost({
            container: searchPostResults,
        }),

        pagination({
            container: document.querySelector('.js-occasion-search-post-pagination'),
            scrollTo: false,
        }),
    ]);

    search.start();

    // handle dial recipe occasion button filtering
    const occasionBtns = document.querySelectorAll('.js-occasion-search-btn');
    occasionBtns.forEach((occasionBtn) => {
        occasionBtn.addEventListener('click', () => {
            const { category } = occasionBtn.dataset;
            if (category === 'all') {
                search.helper
                    .clearRefinements('taxonomies.occasion')
                    .search();
                return;
            }

            search.helper
                .clearRefinements('taxonomies.occasion')
                .toggleFacetRefinement('taxonomies.occasion', category)
                .search();
        });
    });
};

const getRecipes = (searchClient) => {
    const indexName = `${SWDLocalise.algoliaIndex}recipe`;

    let firstRender = false;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const urlParts = location.href.match(/^(.*?)\/occasions/);
                    const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

                    const occasionPath = routeState.occasion
                        ? `${routeState.occasion}/`
                        : '';

                    const queryParameters = {};
                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // handle single URL
                    return `${baseUrl}occasions/${occasionPath}${queryString}`;
                },

                parseURL({ location }) {
                    const pathnameMatches = location.pathname.match(/occasions\/(.*?)\/?$/);
                    const occasion = ((pathnameMatches && pathnameMatches[1]) || '');

                    return {
                        occasion,
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_spb_recipe || {};
                    return {
                        occasion: indexUiState.menu && indexUiState.menu['taxonomies.occasion'],
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_spb_recipe: {
                            menu: {
                                'taxonomies.occasion': routeState.occasion,
                            },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            helper.toggleFacetRefinement('visibility', 'visible');

            if (!firstRender) {
                const recipeResults = document.querySelector('.js-occasion-search-recipe-results');
                if (recipeResults
                    && recipeResults.dataset.selected !== undefined
                    && recipeResults.dataset.selected !== 'all') {
                    helper
                        .clearRefinements('taxonomies.occasion')
                        .toggleFacetRefinement('taxonomies.occasion', recipeResults.dataset.selected);
                }
                firstRender = true;
            }

            if (helper.hasRefinements('taxonomies.occasion')) {
                contentSelect(helper.state.hierarchicalFacetsRefinements['taxonomies.occasion'][0]);
            } else {
                contentSelect('all');
            }

            helper.search();
        },
    });

    const virtualMenuOccasion = connectMenu(() => null);
    const virtualMenuVisibility = connectMenu(() => null);

    search.addWidgets([
        configure({
            hitsPerPage: 8,
            hierarchicalFacets: [{
                name: 'occasions',
                attributes: ['taxonomies.occasion.lvl0'],
            }],
        }),

        virtualMenuOccasion({
            attribute: 'taxonomies.occasion',
        }),

        virtualMenuVisibility({
            attribute: 'visibility',
        }),

        customHitsRecipe({
            container: document.querySelector('.js-occasion-search-recipe-results'),
            isSlider: true,
        }),
    ]);

    search.start();

    search.on('render', () => {
        const sliders = document.querySelectorAll('.js-slider');
        if (sliders.length > 0) {
            sliders.forEach((sliderInstance) => {
                sliderInstance.swiper.update();
            });
        }
    });

    // refine occasion
    const refineOccasion = (category) => {
        updateContent(category);

        if (category === 'all') {
            search.helper
                .clearRefinements('taxonomies.occasion')
                .search();
            return;
        }

        search.helper
            .clearRefinements('taxonomies.occasion')
            .toggleFacetRefinement('taxonomies.occasion', category)
            .search();
    };

    // handle dial recipe occasion button filtering
    const occasionBtns = document.querySelectorAll('.js-occasion-search-btn');
    occasionBtns.forEach((occasionBtn) => {
        occasionBtn.addEventListener('click', () => {
            const { category } = occasionBtn.dataset;
            // call Algolia
            refineOccasion(category);
        });
    });

    // handle dial recipe occasion select filtering
    const occasionSelect = document.querySelector('.js-occasion-search-select');
    occasionSelect.addEventListener('change', (event) => {
        event.preventDefault();
        // call Algolia
        refineOccasion(occasionSelect.value);
    });
};

const init = () => {
    if (!searchPostResults) return;

    const searchClient = setup();
    getRecipes(searchClient);
    getPosts(searchClient);
};

export default init;
